import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, Self, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'lsl-order-control',
  templateUrl: './order-control.component.html',
  styleUrls: ['./order-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderControlComponent implements ControlValueAccessor, OnInit {
  @Input() strings: any[];
  @Input() set reset(value: boolean) {
    if (value) {
      this.answer = [];
      this.onChange(this.answer);
      this.resetChange.emit(false);
    }
  }
  @Output() resetChange = new EventEmitter<boolean>();
  value;
  answer = [];

  model: string[];
  onChange = (value: any) => {};
  onTouched = () => {};
  constructor(@Self() private ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  ngOnInit() {
    this.ngControl.control.valueChanges.subscribe((value) => {
      // Check to ensure the value wasn't already set (Template driven forms)
      if (this.model === value) return;
      this.writeValue(value);
    });
  }

  // Works on copies, as dragula's model binding did, so the parent's `strings` array is never mutated by a drag.
  drop(event: CdkDragDrop<string[]>) {
    const answerChanged = event.container.data === this.answer || event.previousContainer.data === this.answer;
    const strings = [...this.strings];
    const answer = [...this.answer];
    const listOf = (data: string[]) => (data === this.answer ? answer : strings);
    if (event.previousContainer === event.container) {
      moveItemInArray(listOf(event.container.data), event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        listOf(event.previousContainer.data),
        listOf(event.container.data),
        event.previousIndex,
        event.currentIndex
      );
    }
    this.strings = strings;
    this.answer = answer;
    if (answerChanged) {
      this.select(this.answer);
    }
  }

  handleAnswerClick(text: string) {
    this.answer = this.answer.filter((string) => string !== text);
    this.strings.push(text);
    this.select(this.answer);
  }

  handleStringClick(text: string) {
    this.strings = this.strings.filter((string) => string !== text);
    this.answer.push(text);
    this.select(this.answer);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any) {
    this.model = value;
  }

  select(value) {
    if (this.model !== this.value) {
      this.model = value;
      this.onChange(this.model);
    }
  }
}
